import { useAuth } from '../../services/useAuth'
import useCustomGlobalState from './useCustomGlobalState'

const NAVIGATION_MODAL_STATE_KEY = 'navigationModalState'

const useNavigationModalState = () => {
  const [isNavigationModalOpen, setNavigationModalOpen] = useCustomGlobalState(
    NAVIGATION_MODAL_STATE_KEY,
    false,
  )
  const { user } = useAuth()

  const openNavigationModal = () => {
    if (user) {
      setNavigationModalOpen(true)
    }
  }

  const closeNavigationModal = () => {
    setNavigationModalOpen(false)
  }

  return {
    isNavigationModalOpen,
    openNavigationModal,
    closeNavigationModal,
  }
}

export default useNavigationModalState
